<article
  class="alerta-card"
  [class.alerta-card--subiu]="alerta?.direcao === 'subiu'"
  [class.alerta-card--desceu]="alerta?.direcao === 'desceu'"
  [class.alerta-card--30d]="alerta?.janela === '30d'"
  role="status"
  [attr.aria-label]="'Alerta de preço em ' + alerta?.tituloLocal"
>
  <span class="alerta-card__divisor-seta" aria-hidden="true">
    <span class="material-icons">east</span>
  </span>

  <section class="alerta-card__col alerta-card__col--esq">
    <div class="alerta-card__header">
      <div class="alerta-card__trend">
        <span
          class="material-icons alerta-card__trend-icon"
          aria-hidden="true"
          >{{ trendIcon }}</span
        >
        <span class="alerta-card__badge">{{ badgeLabel }}</span>
      </div>
      <time
        class="alerta-card__momento"
        [attr.datetime]="alerta?.momentoIso ?? null"
      >
        {{ alerta?.momentoRelativo }}
      </time>
    </div>

    <h4 class="alerta-card__titulo" [title]="alerta?.tituloLocal">
      {{ alerta?.tituloLocal }}
    </h4>

    <div class="alerta-card__atual">
      <span class="alerta-card__atual-label">Preço atual</span>
      <div class="alerta-card__precos">
        <ng-container *ngIf="temPrecoAnterior">
          <span class="alerta-card__preco alerta-card__preco--anterior"
            >R$ {{ alerta?.precoAnterior | number: "1.2-2" : "pt-BR" }}</span
          >
          <span class="alerta-card__arrow" aria-hidden="true">→</span>
        </ng-container>
        <span class="alerta-card__preco"
          >R$ {{ alerta?.precoAtual | number: "1.2-2" : "pt-BR" }}</span
        >
        <span class="alerta-card__unidade">/ L</span>
      </div>
    </div>
  </section>

  <section class="alerta-card__col alerta-card__col--dir">
    <div
      *ngIf="temMelhorAlternativa; else semAlternativa"
      class="alerta-card__alternativa"
      [class.alerta-card__alternativa--vantajosa]="
        vantagemAlternativa === 'vantajosa'
      "
      [class.alerta-card__alternativa--igual]="vantagemAlternativa === 'igual'"
      [class.alerta-card__alternativa--desvantajosa]="
        vantagemAlternativa === 'desvantajosa'
      "
      [attr.aria-label]="ariaAlternativa"
    >
      <div class="alerta-card__alt-cabecalho">
        <span class="alerta-card__alt-label">
          <span
            class="material-icons alerta-card__alt-label-icon"
            aria-hidden="true"
            >local_gas_station</span
          >
          <span>Melhor alternativa</span>
        </span>
        <span
          class="alerta-card__alt-prox"
          [class.alerta-card__alt-prox--perto]="faixaProximidade === 'perto'"
          [class.alerta-card__alt-prox--medio]="faixaProximidade === 'medio'"
          [class.alerta-card__alt-prox--longe]="faixaProximidade === 'longe'"
        >
          <span
            class="material-icons alerta-card__alt-prox-icon"
            aria-hidden="true"
            >place</span
          >
          <span class="alerta-card__alt-prox-texto">
            <strong>{{ alerta?.melhorAlternativa?.distanciaKm }} km</strong>
            <span class="alerta-card__alt-prox-rotulo">{{
              rotuloProximidade
            }}</span>
          </span>
        </span>
      </div>

      <div class="alerta-card__alt-titulo-linha">
        <span class="alerta-card__alt-titulo" [title]="tituloAlternativa">{{
          tituloAlternativa
        }}</span>
        <span
          class="alerta-card__alt-preco-inline"
          *ngIf="alerta?.melhorAlternativa?.preco !== undefined"
        >
          R$
          {{ alerta?.melhorAlternativa?.preco | number: "1.2-2" : "pt-BR"
          }}<span class="alerta-card__alt-preco-inline-unidade">/ L</span>
        </span>
      </div>

      <div class="alerta-card__alt-economia" *ngIf="economiaPorLitro !== null">
        <span class="alerta-card__alt-economia-rotulo">
          <span
            class="material-icons alerta-card__alt-economia-icon"
            aria-hidden="true"
            >{{ iconeVantagem }}</span
          >
          <span>{{ rotuloVantagem }}</span>
        </span>
        <span class="alerta-card__alt-economia-valor">
          <ng-container *ngIf="vantagemAlternativa === 'vantajosa'"
            >−</ng-container
          >
          <ng-container *ngIf="vantagemAlternativa === 'desvantajosa'"
            >+</ng-container
          >
          R$ {{ economiaPorLitro || 0 | number: "1.2-2" : "pt-BR"
          }}<span class="alerta-card__alt-economia-unidade">/ L</span>
        </span>
        <span
          class="alerta-card__alt-economia-pct"
          *ngIf="economiaPercentual !== null && vantagemAlternativa !== 'igual'"
        >
          {{ vantagemAlternativa === "vantajosa" ? "−" : "+"
          }}{{ economiaPercentual | number: "1.0-1" : "pt-BR" }}%
        </span>
      </div>

      <!-- <div class="alerta-card__alt-comparativo" *ngIf="economiaPorLitro !== null">
        <span class="alerta-card__alt-comparativo-de">
          De <s>R$ {{ alerta?.precoAtual | number: '1.2-2':'pt-BR' }}</s>
        </span>
        <span class="material-icons alerta-card__alt-comparativo-arrow" aria-hidden="true">arrow_right_alt</span>
        <span class="alerta-card__alt-comparativo-por">
          por <strong>R$ {{ alerta?.melhorAlternativa?.preco | number: '1.2-2':'pt-BR' }}/L</strong>
        </span>
      </div> -->

      <!-- <p
        class="alerta-card__alt-projecao"
        *ngIf="vantagemAlternativa === 'vantajosa' && economiaPorTanque !== null"
      >
        <span class="material-icons alerta-card__alt-projecao-icon" aria-hidden="true">local_shipping</span>
        <span>
          Economia de
          <strong>R$ {{ economiaPorTanque | number: '1.2-2':'pt-BR' }}</strong>
          a cada {{ volumeReferencia }} L
        </span>
      </p> -->
    </div>

    <ng-template #semAlternativa>
      <div class="alerta-card__alternativa alerta-card__alternativa--vazia">
        <span
          class="material-icons alerta-card__alt-vazia-icon"
          aria-hidden="true"
          >place_off</span
        >
        <span class="alerta-card__alt-vazia-texto"
          >Sem alternativa próxima</span
        >
      </div>
    </ng-template>
  </section>
</article>
